module.exports = {
    props: ['user', 'team', 'monthly', 'yearly', 'monthlyContracts', 'yearlyContracts'],

    /**
     * The component's data.
     */
    data() {
        const self = this;
        return {
            monthlyChartOptions: null,
            yearlyChartOptions: null,
        };
    },


    /**
     * Prepare the component.
     */
    mounted() {
        this.setMonthlyChartOptions()
        this.setYearlyChartOptions()
    },


    methods: {
        /**
         * Set teams monthly ROI options
         */
        setMonthlyChartOptions() {
            console.log(this.monthlyContractsPercentage);
            this.monthlyChartOptions = {
                credits: {
                    enabled: false
                },
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: 0,
                    plotShadow: false,
                },
                title: {
                    text: this.team.name +" Monthly ROI",
                    align: "center",
                    verticalAlign: "top",

                },
                tooltip: {
                    pointFormat: "<b>{point.percentage:.1f}%</b>",
                },
                plotOptions: {
                    pie: {
                        dataLabels: {
                            enabled: true,
                            distance: -40,
                            alignTo: 'toPlotEdges',
                            style: {
                                fontWeight: "normal",
                                color: "black",
                                textShadow: "0px",
                            }
                        },
                        startAngle: -90,
                        endAngle: 90,
                        center: ["50%", "70%"],
                    },
                },
                series: [
                    {
                        type: "pie",
                        name: "",
                        innerSize: "0%",
                        data: [
                            {
                                name: "Your Investment <br/> $"+this.monthly,
                                y: this.monthlyInvestmentPercentage,
                                color: "#ff7f7f",
                                dataLabels: {
                                    distance: 20,
                                }
                            },
                            {
                                name: "$"+ this.monthlyContracts +"<br/>"+ parseFloat(this.monthlyContractsROI).toFixed(2) + "% ROI",
                                y: this.monthlyContractsPercentage,
                                color: "#81ffa5",
                                dataLabels: {
                                    distance: 20
                                }
                            },
                        ],
                    },
                ],
            }
        },

        setYearlyChartOptions() {
            this.yearlyChartOptions = {
                credits: {
                    enabled: false
                },
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: 0,
                    plotShadow: false,
                },
                title: {
                    text: this.team.name +" Yearly ROI",
                    align: "center",
                    verticalAlign: "top",

                },
                tooltip: {
                    pointFormat: "<b>{point.percentage:.1f}%</b>",
                },
                plotOptions: {
                    pie: {
                        dataLabels: {
                            enabled: true,
                            distance: -40,
                            style: {
                                fontWeight: "normal",
                                color: "black",
                                textShadow: "0px",
                            },
                        },
                        startAngle: -90,
                        endAngle: 90,
                        center: ["50%", "70%"],
                    },
                },
                series: [
                    {
                        type: "pie",
                        name: "",
                        innerSize: "0%",
                        data: [
                            {
                                name: "Your Investment <br/> $"+this.yearly,
                                y: this.yearlyInvestmentPercentage,
                                color: "#ff7f7f",
                                dataLabels: {
                                    distance: 20,
                                }
                            },
                            {
                                name: "$"+this.yearlyContracts + "<br/>" + parseFloat(this.yearlyContractsROI).toFixed(2) + "% ROI",
                                y: this.yearlyContractsPercentage,
                                color: "#81ffa5",
                                dataLabels: {
                                    distance: 20,
                                }
                            },
                        ],
                    },
                ],
            }
        }
    },

    computed: {
        monthlyInvestmentPercentage() {
            return this.monthlyContracts > 0 ?(this.monthly / this.monthlyContracts) * 100 : 100
        },
        monthlyContractsROI() {
            return this.monthlyContracts > 0 ?(this.monthlyContracts / this.monthly) * 100 : 0
        },
        monthlyContractsPercentage() {
            return this.monthlyContracts > 0 ? (this.monthlyContracts / (this.monthly + this.monthlyContracts)) * 100 : 0
        },
        yearlyInvestmentPercentage() {
            return this.yearlyContracts > 0 ? (this.yearly / (this.yearly + this.yearlyContracts)) * 100 : 100
        },
        yearlyContractsROI() {
            return this.yearlyContracts > 0 ? (this.yearlyContracts / this.yearly) * 100 : 0
        },
        yearlyContractsPercentage() {
            return this.yearlyContracts > 0 ? (this.yearlyContracts / (this.yearly + this.yearlyContracts)) * 100 : 0
        },

    }
};
